import React from 'react';
import '../Styles/BankDetails.css';
import qrcode from '../Images/download.png';
import onlinepayment from '../Images/onlinepayment.png';

const BankDetails = () => {

    return (
        <div>
            
            <div className ="bank-details">
                <div className ="neft-details">
                    <h4>Bank Details</h4>
                    <div className ="row-element">
                        <div>Account Name:</div>
                        <div> MOTIWALA TOURISM L.L.C</div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>IBAN:</div>
                        <div>AE390860000009989680362

                        </div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>SWIFT / BIC :</div>
                        <div> WIOBAEADXXX
</div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>Currency:</div>
                        <div>AED
                        </div>
                     </div>
                    <hr/>
                    {/* <div className ="row-element">
                        <div>IFSC Code:</div>
                        <div>INDB0000470</div>
                    </div> */}
                   
                </div> 
            </div>
        </div>
    )

};

export default BankDetails;